module.exports = __webpack_public_path__ + "img/Ertiga-xl7-2023.9f72f172.png";